<template>
    <BaseModal
        @close="handleClose"
    >
        <template #header>
            <h3 id="base-modal-title" class="logout-modal__title" tabindex="-1" ref="logoutTitle">
                {{ $ml.get('logoutModalTitle') }}
            </h3>
        </template>

        <span class="logout-modal__subtitle">{{ $ml.get('logoutModalSubtitle') }}</span>

        <template #footer>
            <button class="base-modal__btn base-modal__btn--gray" @click="handleClose" ref="cancelBtn">
                {{ $ml.get('back') }}
            </button>
            <button class="base-modal__btn base-modal__btn--danger" @click="handleLogout">
                <ClipLoader v-if="loading" color="#fff" size="14px" />
                <span v-else>{{ $ml.get('logout') }}</span>
            </button>
        </template>
    </BaseModal>
</template>

<script>
    import BaseModal from '@/components/template/BaseModal';
    import ClipLoader from 'vue-spinner/src/ClipLoader';
    
    export default {
        components: {
            BaseModal,
            ClipLoader
        },

        data() {
            return {
                loading: false,
            };
        },

        mounted() {
            // Foco automático no título para leitores de tela
            this.$nextTick(() => {
                if (this.$refs.logoutTitle) {
                    this.$refs.logoutTitle.focus();
                }
            });
            // Fechar com ESC
            document.addEventListener('keydown', this.handleEsc);
        },

        beforeDestroy() {
            document.removeEventListener('keydown', this.handleEsc);
        },
        
        methods: {
            handleClose() {
                if(this.loading) return;
                this.$store.dispatch('dataOnFile/setShowLogoutModal', false);
            },
            
            handleEsc(e) {
                if (e.key === 'Escape') {
                    this.handleClose();
                }
            },

            async handleLogout() {
                try {
                    this.loading = true;
                    await this.$store.dispatch('dataOnFile/clearDofSession', false);
                } catch (error) {
                    console.error('Erro ao fazer logout:', error);
                } finally {
                    this.loading = false;
                    this.$store.dispatch('pipeline/pushTo', 'Identification');
                    this.handleClose();
                }
			}
        },
    };
</script>

<style scoped lang="scss">

    .logout-modal {
        &__title {
            font-size: 1.25rem;
            font-weight: 700;
            color: #2F363E;
        }

        &__subtitle {
            font-size: 1rem;
            font-weight: 500;
            color: #454F5C;
        }

    }

</style>